<template>
  <div v-if="editModel">
    <el-form
      ref="form"
      :size="$xUISize"
      :model="editModel"
      :rules="editRules"
      @submit.native.prevent
      label-width="auto"
      label-position="top"
    >
      <el-card v-loading="loading" shadow="hover">
        <div style="padding: 10px 20px">
          <el-form-item label="货位组数" prop="groupCount">
            <el-input
              placeholder="请输入货位组数"
              v-model="editModel.groupCount"
            ></el-input>
          </el-form-item>
          <el-form-item label="货位列数" prop="columnCount">
            <el-input
              placeholder="请输入货位列数"
              v-model="editModel.columnCount"
            ></el-input>
          </el-form-item>
          <el-form-item label="货位层数" prop="rowCount">
            <el-input
              type="number"
              v-model="editModel.rowCount"
              placeholder="请输入货位层数"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
  </div>
  <el-card v-else-if="!loading" shadow="hover">
    <el-empty :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
    </el-empty>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
const defaultModel = {
  groupCount: "",
  columnCount: "",
  rowCount: "",
};

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        groupCount: [
          {
            required: true,
            message: "请输入货位组数",
            trigger: "change",
          },
        ],
        columnCount: [
          {
            required: true,
            message: "请输入货位列数",
            trigger: "change",
          },
        ],
        rowCount: [
          {
            required: true,
            message: "请输入货位层数",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = "biz.customer.store.shelf.batchCreate";
          this.requestApi(method, this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("保存成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
    },
    fetchModel() {
      // 新增
      this.editModel = Object.assign({}, defaultModel);
      this.handleModel();
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
